import { NgModule } from "@angular/core";
import { StoreStatusComponent } from "./store-status.component";
import { AutoMapperService } from "../../../services/Common/auto-mapper.service";
import { AdminCommonModule } from "../../admin/admin-common.module";

@NgModule({
    declarations: [
        StoreStatusComponent
    ],
    imports: [
        AdminCommonModule
    ],
    exports: [
        StoreStatusComponent
    ],
    providers: [
        AutoMapperService
    ]
})
export class StoreStatusModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/store-status/store-status.module.ts